<ng-container *ngIf="videos().length">
  <ng-container *ngIf="id && tipoTarjeta">
    <app-tarjeta-info-autor [id]="id" [tipoTarjeta]="tipoTarjeta"></app-tarjeta-info-autor>
  </ng-container>
  <div class="contenedor-listado-noticias">
    <ng-container *ngFor="let item of videos() | slice: 0 : 45; let i = index; trackBy: trackByItem">
      <app-noticia-listado class="div{{ i + 1 }}" [idStart]="i" [noticia]="item"></app-noticia-listado>
      <ng-container *ngIf="i % 3 === 1">
        <div class="publi-m publi-container-movil">
          <ng-container *ngIf="publicidadSeccion3?.enlace; else noEnlace3">
            <a href="{{ publicidadSeccion3?.enlace }}" target="_blank">
              <img src="{{ publicidadSeccion3?.img }}" alt="publicidad" loading="lazy" width="100%" height="100%" />
            </a>
          </ng-container>
          <ng-template #noEnlace3>
            <div id="publi-seccion-movil-{{ (i - 1) / 3 }}" class="publicidad publi-seccion-movil-{{ (i - 1) / 3 }}"></div>
          </ng-template>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="videos()[10]">
      <div class="publi publi-container">
        <ng-container *ngIf="publicidadSeccion1?.enlace; else noEnlace1">
          <a *ngIf="publicidadSeccion1?.enlace" href="{{ publicidadSeccion1?.enlace }}" target="_blank">
            <img src="{{ publicidadSeccion1?.img }}" alt="publicidad" loading="lazy" width="100%" height="100%" />
          </a>
        </ng-container>
        <ng-template #noEnlace1>
          <div id="publi-seccion-1" class="publicidad publi-seccion-1"></div>
        </ng-template>
      </div>
    </ng-container>

    <ng-container *ngIf="videos()[20]">
      <div class="publi2 publi-container">
        <ng-container *ngIf="publicidadSeccion2?.enlace; else noEnlace2">
          <a *ngIf="publicidadSeccion2?.enlace" href="{{ publicidadSeccion2?.enlace }}" target="_blank">
            <img src="{{ publicidadSeccion2?.img }}" alt="publicidad" loading="lazy" width="100%" height="100%" />
          </a>
        </ng-container>
        <ng-template #noEnlace2>
          <div id="publi-seccion-2" style="max-width: 300px; height: auto" class="publicidad publi-seccion-2"></div>
        </ng-template>
      </div>
    </ng-container>

    <ng-container *ngIf="videos()[30]">
      <div class="publi3 publi-container">
        <ng-container *ngIf="publicidadSeccion3?.enlace; else noEnlace4">
          <a href="{{ publicidadSeccion3?.enlace }}" target="_blank">
            <img src="{{ publicidadSeccion3?.img }}" alt="publicidad" loading="lazy" width="100%" height="100%" />
          </a>
        </ng-container>
        <ng-template #noEnlace4>
          <div id="publi-seccion-3" class="publicidad publi-seccion-3"></div>
        </ng-template>
      </div>
    </ng-container>

    <ng-container *ngIf="videos()[10]">
      <div class="publi4 publi-banner-container">
        <ng-container *ngIf="publicidadSeccion3?.enlace; else noEnlace5">
          <a href="{{ publicidadSeccion3?.enlace }}" target="_blank">
            <img src="{{ publicidadSeccion3?.img }}" alt="publicidad" loading="lazy" width="100%" height="100%" />
          </a>
        </ng-container>
        <ng-template #noEnlace5>
          <div id="DIVISOR_SECCION_1" class="publicidad DIVISOR_SECCION_1"></div>
        </ng-template>
      </div>
    </ng-container>

    <ng-container *ngIf="videos()[20]">
      <div class="publi5 publi-banner-container">
        <ng-container *ngIf="publicidadSeccion3?.enlace; else noEnlace6">
          <a href="{{ publicidadSeccion3?.enlace }}" target="_blank">
            <img src="{{ publicidadSeccion3?.img }}" alt="publicidad" loading="lazy" width="100%" height="100%" />
          </a>
        </ng-container>
        <ng-template #noEnlace6>
          <div id="DIVISOR_SECCION_2" class="publicidad DIVISOR_SECCION_2"></div>
        </ng-template>
      </div>
    </ng-container>
    <ng-container *ngIf="videos()[30]">
      <div class="publi6 publi-banner-container">
        <ng-container *ngIf="publicidadSeccion3?.enlace; else noEnlace7">
          <a href="{{ publicidadSeccion3?.enlace }}" target="_blank">
            <img src="{{ publicidadSeccion3?.img }}" alt="publicidad" loading="lazy" width="100%" height="100%" />
          </a>
        </ng-container>
        <ng-template #noEnlace7>
          <div id="DIVISOR_SECCION_3" class="publicidad DIVISOR_SECCION_3"></div>
        </ng-template>
      </div>
    </ng-container>
  </div>
</ng-container>
